var map = {
	"./q1.png": 8939,
	"./q2.png": 3536,
	"./q3.png": 9289,
	"./q4.png": 662,
	"./q5.png": 9407,
	"./q6.png": 6948,
	"./q7.png": 8077,
	"./q8.png": 1482,
	"./q9.png": 2243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;